import { get } from 'lodash';
import * as React from 'react';
import { connect } from 'react-redux';
import { AuthoritiesContribution } from '../../../../../components/widgets/shared/authority/authority-contrtibution/authorities-contribution';
import { connectNLP } from '../../../../../utilities/connect-navigate';
import { Contributions } from '../contributions';

const mapStateProps = (store: any) => ({
	user: store.user.user,
});

const mapDispatchProps = (dispatch: any) => ({});

class SubAuthoritiesContributionsComponent extends Contributions<any, any> {
	public endpoint(): any {
		const user = get(this.props, 'user');
		const userRoles = get(user, 'roles');
		const isAdmin = userRoles.includes('ADMIN');
		const system = get(this.props, 'system');
		const systemInfo = system === true ? '/system' : `/users/${system}`;
		const otherInfo = isAdmin ? '' : `/users/${get(user, 'aid')}`;

		const systemAdminOrGeneral = isAdmin && system ? systemInfo : otherInfo;
		const airportOrCountry = this.props.isAirport
			? 'airportauthorities'
			: 'countryauthorities';

		return `/${airportOrCountry}/contributions${systemAdminOrGeneral}`;
	}

	public getType(): string {
		return this.props.isAirport ? 'authorities' : 'countryauthorities';
	}

	public getModalEndpoint() {
		return `/${
			this.props.isAirport ? 'airportauthorities' : 'countryauthorities'
		}/${get(this.state.item, 'entityAid')}`;
	}

	public renderModalContent(ctx): React.ReactElement {
		return (
			<AuthoritiesContribution
				close={() => this.onModalClose()}
				isCountry={!this.props.isAirport}
				item={this.state.item}
				onSuccess={() => this.handleModalSuccess()}
				original={get(ctx.state, 'response')}
			/>
		);
	}
}

export const SubAuthoritiesContributions: any = connect(
	mapStateProps,
	mapDispatchProps,
	null,
	{ forwardRef: true }
)(connectNLP(SubAuthoritiesContributionsComponent));
